import { classNames } from "../../common/lib/classNames";
import { IHeroIcon } from "../../main/types/types";

// Shared look for the portal invoice and statement pages
export const toolbarButton = `inline-flex cursor-pointer h-[2.125rem] shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg border border-gray-300 bg-white px-3 text-[0.8125rem] font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50`;

export const payButton = `flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg px-[1.125rem] text-[0.9375rem] font-semibold`;

export const primaryPayButton = `${payButton} bg-paidniceGreen-600 text-white hover:bg-paidniceGreen-700`;

export const card = `overflow-hidden rounded-xl border border-gray-200 bg-white`;

const bannerTones = {
  green: `border-green-200 bg-green-50 text-green-700`,
  amber: `border-amber-200 bg-amber-50 text-amber-800`,
};

export function Banner({ tone, icon: Icon, children }: { tone: keyof typeof bannerTones; icon: IHeroIcon; children: React.ReactNode }) {
  return (
    <div className={ classNames(`flex flex-wrap items-center gap-2.5 rounded-[0.625rem] border px-4 py-3 text-sm`, bannerTones[tone]) }>
      <Icon className={ `h-[1.125rem] w-[1.125rem] shrink-0` } />
      { children }
    </div>
  );
}

/** Segmented control, e.g. Card / Direct Debit or AUD / NZD */
export function Segmented<T extends string>({ options, value, onChange, className }: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <div className={ classNames(`flex gap-0.5 rounded-lg bg-gray-100 p-[3px]`, className) }>
      { options.map(o => (
        <button
          key={ o.value }
          type={ `button` }
          onClick={ () => onChange(o.value) }
          className={ classNames(
            `h-7 flex-1 cursor-pointer whitespace-nowrap rounded-md px-2.5 text-xs`,
            o.value === value ? `bg-white font-semibold text-paidniceGreen-800 shadow-xs` : `text-gray-600 hover:text-gray-900`,
          ) }
        >
          { o.label }
        </button>
      )) }
    </div>
  );
}
